import React, { useContext } from 'react';
import countriesDictionaryEn from "../../../dictionaries/countries/en/countries.json";
import countriesDictionarySv from "../../../dictionaries/countries/sv/countries.json";
import positionsDictionaryEn from "../../../dictionaries/positions/en/positions.json";
import positionsDictionarySv from "../../../dictionaries/positions/sv/positions.json";
import {getPlayerUrlById, getTeamUrl} from "../../../utils/routes";

function Translate(phrase, en, sv) {
    let translation;
    let translationId;
    en.map((dictionaryEn) => {
        if (dictionaryEn.name === phrase) {
            translationId = dictionaryEn.id;
        }
    });
    sv.map((dictionarySv) => {
        if (dictionarySv.id === translationId ) {
            translation = dictionarySv.name;
        }
    });
    return translation ? translation : phrase;
}
const PlayersTableRow = ({player, i, orderBy}) => {
    const countrySv = Translate(player?.nationality, countriesDictionaryEn, countriesDictionarySv);
    const positionSv = Translate(player?.position, positionsDictionaryEn, positionsDictionarySv);
    const playerUrl = getPlayerUrlById(player?.fogisId);
    const teamUrl = (player?.teamAbbrv) ? getTeamUrl(player?.teamAbbrv) : '';
    const teamLogo =  (player?.teamLogo && player?.teamDisplayName) ? player?.teamLogo : '/wp-content/themes/sef-leagues/images/generic-team.png';
    return (
        <div className='stats-table__row'>
            <div className="col-1 col-md-1 text-center stats-font-larger">{i}</div>
            <a style={{ pointerEvents: playerUrl ? 'auto' : 'none' }}
               href={playerUrl ? playerUrl : ''}
               className="col-9 col-md-3 name-with-team-logo name-with-team-logo--desktop-hide-logo">
                <div className="name-with-team-logo name-with-team-logo--desktop-hide-logo">
                    <img src={teamLogo} />
                    <span className="d-none d-sm-inline-block text-color-primary-white stats-font-larger">{player?.displayName}</span>
                    <span className="d-inline-block d-sm-none text-color-primary-white stats-font-larger">{player?.displayName}</span>
                </div>
            </a>
            <a  style={{ pointerEvents: teamUrl ? 'auto' : 'none' }}
                href={teamUrl} className="col-auto col-md-2 d-none d-md-block name-with-team-logo name-with-team-logo--mobile-hide-logo">
                <div className="name-with-team-logo name-with-team-logo--mobile-hide-logo">
                    <img src={teamLogo} />
                    <span className="d-none d-sm-inline-block text-color-primary-white">{player?.teamDisplayName}</span>
                    <span className="d-inline-block d-sm-none text-color-primary-white">{player?.teamDisplayName}</span>
                </div>
            </a>
            <div className="col-auto col-md-2 d-none d-md-block">{positionSv}</div>
            <div className="col-auto col-md-2 d-none d-md-block">{countrySv}</div>
            <div className="col-auto col-md-1 text-center d-none d-md-block">{player?.matchesPlayed}</div>
            <div className="col-auto col-md-1 text-center stats-font-larger">{player[orderBy]}</div>
        </div>
    )
}
export default PlayersTableRow;